<template>
    <div class="public-price-calculator">
        <div class="public-price-calculator_title">{{ t("public.calculator.select_product") }}</div>
        <div class="public-price-calculator__product_list">
            <div
                class="public-price-calculator__product_list_item"
                v-for="(item, index) in services"
                :key="`product-calculate-${index}-${item.id}`"
                @click="toggleProduct(item)"
                :class="{ active: checkSelected(item.id) }"
            >
                <div class="public-price-calculator__product_list_item_icon">
                    <component :is="getIconBySlug(item.slug)"></component>
                </div>
                {{ item.title }}
            </div>
        </div>
        <div class="public-price-calculator_title">{{ t("public.calculator.cost_calculation") }}</div>
        <div class="public-price-calculator__pricing">
            <div class="public-price-calculator__pricing_item">
                {{ t("public.calculator.cost_per_product") }}:
                <div class="public-price-calculator__pricing_item_price">
                    {{ t("public.calculator.from") }} <span>${{ startPrice }}</span>
                </div>
            </div>
            <div class="public-price-calculator__pricing_item">
                {{ t("public.calculator.start_bonus") }}:
                <div
                    class="public-price-calculator__pricing_item_price public-price-calculator__pricing_item_price_bonus"
                >
                    <span>${{ startBonus }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PublicHatIcon from "@icons/PublicHatIcon"
import GroupUsersIcon from "@icons/GroupUsersIcon"
import PublicLetterIcon from "@icons/PublicLetterIcon"
import CrmIconIcon from "@icons/CrmIconIcon"
import GamepadIcon from "@icons/GamepadIcon"
import TasselIcon from "@icons/TasselIcon"
import CheckListIcon from "@icons/CheckListIcon"
import PublicCloudIcon from "@icons/PublicCloudIcon"
import keyTranslator from "@mixins/keyTranslator"
import axios from "axios"

export default {
    name: "PublicPriceCalculator",
    data() {
        return {
            selectedProduct: [],
            langsKeys: null
        }
    },
    props: {
        services: Array
    },
    mixins: [keyTranslator],
    components: {
        PublicHatIcon,
        GroupUsersIcon,
        PublicLetterIcon,
        CrmIconIcon,
        GamepadIcon,
        TasselIcon,
        CheckListIcon,
        PublicCloudIcon
    },
    computed: {
        startPrice() {
            return this.selectedProduct.reduce((acum, item) => {
                return acum + +item.price
            }, 0)
        },
        startBonus() {
            return this.selectedProduct.reduce((acum, item) => {
                return acum + +item.default_bonus
            }, 0)
        }
    },
    methods: {
        setDefaultProducts() {
            this.selectedProduct.push(this.services[0])
        },
        checkSelected(id) {
            return this.selectedProduct.find(product => product.id === id)
        },
        toggleProduct(item) {
            if (this.selectedProduct.find(product => product.id === item.id)) {
                this.selectedProduct = this.selectedProduct.filter(product => product.id !== item.id)
                return
            }
            this.selectedProduct.push(item)
        },
        getLangs() {
            axios
                .get(window.cached_routes["translation-groups"], {
                    params: {
                        groups: "pricing",
                        lang: window.app_current_locale
                    },
                    headers: { "X-Language": window.app_current_locale }
                })
                .then(response => {
                    this.langsKeys = response.data
                })
        },
        getIconBySlug(slug) {
            let icon = "PublicHatIcon"
            switch (slug) {
                case "school":
                    icon = "PublicHatIcon"
                    break
                case "webinar":
                    icon = "GroupUsersIcon"
                    break
                case "tools":
                    icon = "CheckListIcon"
                    break
                case "crm":
                    icon = "CrmIconIcon"
                    break
                case "mailer":
                    icon = "PublicLetterIcon"
                    break
                case "chat-bot":
                    icon = "GamepadIcon"
                    break
                case "site-builder":
                    icon = "TasselIcon"
                    break
                case "storage":
                    icon = "PublicCloudIcon"
                    break
            }
            return icon
        }
    },
    async created() {
        await this.getLangs()
        await this.setDefaultProducts()
    }
}
</script>

<style lang="sass" scoped>
.public-price-calculator
    margin-top: 50px
    margin-bottom: 60px
    &_title
        font-family: 'Lato'
        font-weight: 700
        font-size: 28px
        line-height: 130%
        color: #151515
        margin-bottom: 20px
        @media screen and (max-width: 480px)
            font-size: 20px
        @media screen and (max-width: 320px)
            font-size: 16px
    &__product_list
        display: flex
        flex-wrap: wrap
        gap: 8px
        margin-bottom: 60px
        @media screen and (max-width: 320px)
            gap: 10px
        &_item
            background: #FFFFFF
            box-shadow: 0px 10px 20px rgba(213, 221, 230, 0.4)
            border-radius: 10px
            font-family: 'Lato'
            font-style: normal
            font-weight: 600
            font-size: 20px
            line-height: 130%
            text-align: center
            color: #151515
            display: flex
            align-items: center
            cursor: pointer
            padding: 15px 20px
            @media screen and (max-width: 1500px)
                padding: 15px
                font-size: 17px
            @media screen and (max-width: 480px)
                font-size: 16px
                padding: 15px 20px
            &.active
                color: #fff
                background: #58A5FF
                svg
                    fill: #fff
            &:hover
                &:not(.active)
                    color: #3965FF
                    svg
                        fill: #3965FF

            &_icon
                margin-right: 10px
                svg
                    display: block
    &__pricing
        display: flex
        align-items: center
        @media screen and (max-width: 640px)
            display: block
        &_item
            font-family: 'Lato'
            font-weight: 500
            font-size: 20px
            line-height: 130%
            color: #151515
            display: flex
            align-items: baseline
            margin-right: 80px
            @media screen and (max-width: 480px)
                font-size: 16px
            @media screen and (max-width: 640px)
                margin-right: 0
                margin-bottom: 20px
            &_price
                box-shadow: 0px 10px 20px rgba(213, 221, 230, 0.4)
                border-radius: 10px
                padding: 15px 30px
                margin-left: 10px
                align-items: baseline
                &_bonus
                    background: #FA567B
                    color: #fff
                span
                    font-weight: 700
                    font-size: 30px
                    @media screen and (max-width: 480px)
                        font-size: 24px
                    @media screen and (max-width: 320px)
                        font-size: 20px
</style>
